














































































































































import { Component, Prop, InjectReactive, Vue } from 'vue-property-decorator'

// Models
import NaviModel from '@/_models/NaviModel'
import CardModel from '@/_models/CardModel'

// Helpers
import { getLocationTextNavi } from '@/_utils/user'

// Components
import LastUpdatedJbox from '@/components/shared/LastUpdatedJbox.vue'
import BatteryLevel from '@/components/shared/BatteryLevel.vue'

@Component({
  components: { LastUpdatedJbox, BatteryLevel },
})
export default class DripNaviContent extends Vue {
  @InjectReactive('navi-data')
  naviItems!: NaviModel[]

  @InjectReactive('navi-blink')
  isBlinkRefresh!: boolean

  @InjectReactive('navi-height')
  height!: number

  detailOpen: any = {}

  get cards(): CardModel[] {
    return this.$store.state.cards.all.items
  }

  isNothing(navi: NaviModel) {
    return navi.flow.toLowerCase() === 'nothing'
  }

  flowText(navi: NaviModel) {
    const flowI18n = `label.dripnavi_${navi.flow}`
    return this.$t(flowI18n)
  }

  statusTypeClass(navi: NaviModel) {
    const key = navi.flow.toLowerCase()
    const status = {
      normal: 'btn-blink--green',
      low: 'btn-blink--yellow',
      high: 'btn-blink--red',
      no: 'btn-blink--red',
    }

    return status[key]
  }

  getUserLocationText(navi) {
    return getLocationTextNavi(navi, this.cards) || this.$t('label.positioning')
  }

  isOpenDetail(navi: NaviModel) {
    return !!this.detailOpen[navi.san_id]
  }

  onDetailToggle(navi: NaviModel) {
    return (this.detailOpen[navi.san_id] = !this.detailOpen[navi.san_id])
  }
}
